import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ITravelRequest } from '../../models/travel-request.model';

@Component({
  selector: 'app-edit-travel-request-dialog',
  templateUrl: './edit-travel-request-dialog.component.html',
  styleUrls: ['./edit-travel-request-dialog.component.scss'],
  standalone: false,
})
export class EditTravelRequestDialogComponent {
  dialogRef = inject<MatDialogRef<EditTravelRequestDialogComponent>>(MatDialogRef);
  data = inject<ITravelRequest>(MAT_DIALOG_DATA);

  actionClick(result): void {
    this.dialogRef.close(result);
  }
}
